import { z } from "zod";
import { AgencyIdSchema } from "../../primitives/ids.js";
import { AssignmentV1Schema, ClientContactV1Schema, DeliveryProjectV1Schema, DeliveryStatusEventV1Schema, MilestoneV1Schema, OperationalNoteV1Schema, WorkItemV1Schema, } from "./entities.js";
export const CLIENTOPS_WEBSITE_DELIVERY_STORE_SCHEMA_VERSION = "clientops-website-delivery-store.v1.0";
export const ClientOpsWebsiteDeliveryStoreV1Schema = z
    .object({
    schemaVersion: z.literal(CLIENTOPS_WEBSITE_DELIVERY_STORE_SCHEMA_VERSION),
    agencyId: AgencyIdSchema,
    deliveryProjects: z.array(DeliveryProjectV1Schema),
    workItems: z.array(WorkItemV1Schema),
    milestones: z.array(MilestoneV1Schema),
    assignments: z.array(AssignmentV1Schema),
    clientContacts: z.array(ClientContactV1Schema),
    deliveryStatusEvents: z.array(DeliveryStatusEventV1Schema),
    operationalNotes: z.array(OperationalNoteV1Schema),
})
    .strict();
export function emptyClientOpsWebsiteDeliveryStore(agencyId) {
    return ClientOpsWebsiteDeliveryStoreV1Schema.parse({
        schemaVersion: CLIENTOPS_WEBSITE_DELIVERY_STORE_SCHEMA_VERSION,
        agencyId,
        deliveryProjects: [],
        workItems: [],
        milestones: [],
        assignments: [],
        clientContacts: [],
        deliveryStatusEvents: [],
        operationalNotes: [],
    });
}
//# sourceMappingURL=store.js.map